jQuery(document).ready(function(){
    // $('.multiservice_card .multiservice_cardInfo').click(function(){
    //     $(this).parent().find('a').click();
    // });
});